<template>
  <div>
    <div id="gosee-nav">
      <span class="gosee-exit" v-on:click="backToHistory()"
        >&lt;&nbsp;&nbsp;返回</span
      >
      <img src="@/assets/images/result-title.png" class="result-title" />
      <!-- <h3 ng-click="gsc.comment()"></h3> -->
    </div>
    <img
      src="@/assets/images/bgTitle.png"
      style="width: 100%;vertical-align: top;height: 18px;"
    />
    <div id="gosee-product">
      <ul>
        <li>
          <div class="gosee-message-container">
            <div
              class="gosee-message-title gosee-messagess"
              style="margin: 0 auto 5%;"
            >
              <div class="title-name-bg">
                <p class="title-name">
                  {{ result.quizName }}&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
                    result.requestGender == 1 ? '男' : '女'
                  }}</span>
                </p>
                <p class="title-name-birth">公历：{{ result.requestYear }}年</p>
                <p class="title-name-birth">农历：{{ result.soalrday }}年</p>
                <img
                  src="@/assets/images/mo.png"
                  class="mo"
                  style="width: 25%;"
                />
              </div>
            </div>
            <div class="resultContentOnebg">
              <div class="resultContentborder">
                <img
                  src="@/assets/images/xmxx.png"
                  style="width:100%;margin-bottom: 10px;"
                />
                <div class="resultContentborder-l">
                  <span>{{ result.resultname }}</span
                  ><br />
                  <span>{{ result.resultxs }}</span
                  ><br />
                </div>
                <div class="resultContentborder-r">
                  <span>{{ result.resultsnny }}</span
                  ><br />
                  <span>{{ result.resultzygx }}</span
                  ><br />
                </div>
                <div class="resultContentborder-l1">
                  <div v-for="(item, index) in result.flnameList" :key="index">
                    <span class="pl4">{{ item }}</span>
                  </div>
                </div>
                <div class="resultContentborder-r1">
                  <div v-for="(item, index) in result.bihuaList" :key="index">
                    <span class="pl4">{{ item }}</span>
                  </div>
                </div>
                <span class="pl4">{{ result.resulttg }}</span>
                <br />
                <span class="pl4">{{ result.resultrg }}</span>
                <br />
                <span class="pl4">{{ result.resultdg }}</span>
                <br />
                <span class="pl4">{{ result.resultwg }}</span>
                <br />
                <span class="pl4">{{ result.resultzg }}</span>
                <br />
              </div>
              <div class="clear"></div>
            </div>
            <div
              class="gosee-message-title gosee-messagess"
              v-for="(showListConent, index) in result.showListConent"
              :key="index"
            >
              <div class="careerLuckTitle">
                <p class="gosee-message-small-title">
                  <img
                    :src="getTitleImg(showListConent.title)"
                    style="width:100%;"
                  />
                </p>
                <p
                  class="gosee-message-small-message"
                  style="text-indent: 30px;"
                >
                  {{ showListConent.message }}
                </p>
              </div>
            </div>
            <div class="gosee-message-title gosee-messagess">
              <img src="@/assets/images/ywqm.png" style="width:100%;" />
              <img
                v-if="result.fiveElement"
                :src="getTitleImg(result.fiveElement)"
                style="width:100%;"
              />
              <p class="attr-summary">
                纵观你的姓名与生辰，你的命里特别缺<span>{{
                  result.fiveElementName
                }}</span
                >，可用{{ result.fiveElementName }}属性的英文名改善运势。
              </p>
              <p class="attr-summary-pad"></p>
              <div class="gose-english-name-bg">
                <p class="tuijian-english-name-title">
                  最适合你的强运英文名如下
                </p>
                <div class="tuijian-english-name-bg">
                  <p class="tuijian-english-name">
                    {{ result.englishName.name }}
                  </p>
                  <p>释义：{{ result.englishName.explain }}</p>
                </div>

                <img
                  src="@/assets/images/english-bar.png"
                  style="width:94%;display:block;margin: 5% auto"
                />
                <!-- <div class="english-name-more-bg">
                  <p class="english-name-more-title">
                    更多推荐：<span
                      class="rt"
                      ng-click="gsc.getXingMingCeSuanRefreshEnglishNamePromote()"
                      >换一批
                      <img
                        src="@/assets/images/resharsh.png"
                        width="20"
                        class="resharsh"
                    /></span>
                  </p>
                  <p
                    v-for="(promoteEnglishName,
                    index) in result.promoteEnglishName"
                    :key="index"
                    class="promoteEnglishName"
                  >
                    <span class="promoteEnglishName-name">{{
                      promoteEnglishName.name
                    }}</span
                    ><span></span
                    ><span
                      class="rt"
                      v-html="promoteEnglishName.explains"
                      ng-click="gsc.showEnglishName($index)"
                    ></span>
                  </p>
                </div> -->
              </div>
            </div>
          </div>
          <!-- <taotaoxi-propay></taotaoxi-propay> -->
        </li>
      </ul>
    </div>
    <!-- <div id="gosee-error" ng-hide="{{!gsc.error}}">
      <img src="@/assets/images/error.png" width="100%" />
      <span
        style=" display: block;margin-top: -74%;text-align: center;position: relative;font-size: 18px;color: black;"
        ng-bind-html="gsc.errordesc"
      ></span>
      <span class="gosee-sp1">复制信息联系客服</span>
      <span class="gosee-sp2">QQ:2674691447</span>
      <span class="gosee-sp3">TEL:13070197901</span>
    </div> -->
    <!-- <div class="english-name-fixed" v-show="result.EnglishName">
      <div class="show-english-name">
        <div class="tuijian-english-name-bg">
          <span ng-click="gsc.hideEnglishName()" class="hideEnglishName"></span>
          <p class="tuijian-english-name">{{ result.englishNames.name }}</p>
          <p>释义：{{ result.englishNames.explain }}</p>
        </div>
        <div class="english-name-qushi">
          <p>本英文名最近的全球趋势状况如下：</p>
          <p class="english-name-qushi-hints">
            横轴代表年份，纵轴代表姓名使用热度
          </p>
          <img :src="result.englishNames.trendPicture" style="width:100%;" />
        </div>
        <div class="english-name-qushi-hint">
          <p style="padding: 2% 0">趋势图说明：</p>
          <p>盛行年代：{{ result.englishNames.hotYear }}年</p>
          <p>最近排名：{{ result.englishNames.rank }}</p>
          <p v-if="result.englishNames.trend > 0">
            最近趋势：上升{{ result.englishNames.trend }}%
          </p>
          <p v-if="result.englishNames.trend <= 0">
            最近趋势：下降{{ result.englishNames.trend }}%
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import store from '../store'

import { mapGetters } from 'vuex'

export default {
  name: 'Result',
  data() {
    return {
      result: null,
      ready: false
    }
  },
  beforeRouteEnter(to, from, next) {
    if (
      'undefined' === typeof store.getters['fortune/search'](to.params.orderNo)
    ) {
      var payload = {
        ttxid: store.state.user.ttxid,
        token: store.state.user.token,
        timestamp: store.state.user.timestamp,
        orderNo: to.params.orderNo
      }
      store.dispatch('fortune/getResult', payload).then(
        () => {
          next()
        },
        err => {
          alert('尚未支付')
          next({ name: 'Home' })
        }
      )
    } else {
      next()
    }
  },
  created: function() {
    this.result = { ...this.search(this.$route.params.orderNo) }

    this.result.soalrday = soalr(this.result.requestYear)
    this.result.resultname = this.result.lifeAnalyze[0]
    this.result.resultsngz = this.result.lifeAnalyze[1]
    this.result.resultsx = this.result.lifeAnalyze[2]
    this.result.resultsnny = this.result.lifeAnalyze[3]
    this.result.resultxs = this.result.lifeAnalyze[4]
    this.result.resultzygx = this.result.lifeAnalyze[5]
    this.result.englishName = { ...this.result.englishName }

    /*计算名字所在i*/
    var trdwgList = []
    var nameList = []
    var bihuaList = []
    var flnameList = []
    //切出多余
    for (var i = 0; i < this.result.lifeAnalyze.length; i++) {
      if (this.result.lifeAnalyze[i].substring(2, 0) == '天格') {
        this.result.resulttg = this.result.lifeAnalyze[i]
        trdwgList.push(i)
      } else if (this.result.lifeAnalyze[i].substring(2, 0) == '人格') {
        this.result.resultrg = this.result.lifeAnalyze[i]
        trdwgList.push(i)
      } else if (this.result.lifeAnalyze[i].substring(2, 0) == '地格') {
        this.result.resultdg = this.result.lifeAnalyze[i]
        trdwgList.push(i)
      } else if (this.result.lifeAnalyze[i].substring(2, 0) == '外格') {
        this.result.resultwg = this.result.lifeAnalyze[i]
        trdwgList.push(i)
      } else if (this.result.lifeAnalyze[i].substring(2, 0) == '總格') {
        this.result.resultzg = this.result.lifeAnalyze[i]
        trdwgList.push(i)
      }
      if (i > 5) {
        nameList.push(i)
      }
    }
    //计算姓名笔画
    for (var i = 0; i < nameList.length; i++) {
      for (var j = 0; j < trdwgList.length; j++) {
        if (trdwgList[j] == nameList[i]) {
          nameList.splice(i, 1)
        }
      }
    }
    //切出姓名/笔画
    for (var i = 0; i < nameList.length; i++) {
      // nameList.splice(i, 1, userList.lifeAnalyze[nameList[i]]);
      if (this.result.lifeAnalyze[nameList[i]].length == 1) {
        flnameList.push(this.result.lifeAnalyze[nameList[i]])
      } else {
        bihuaList.push(this.result.lifeAnalyze[nameList[i]])
      }
    }
    this.result.flnameList = flnameList
    this.result.bihuaList = bihuaList
    this.result.showListConent = [
      {
        title: 'gxjs',
        message: this.result.answerList[0].contents[0]
      },
      {
        title: 'gqfx',
        message: this.result.answerList[1].contents[0],
        describe:
          '从<span>生肖角度</span>分析最适合的感情模式，<span>帮助你找到最合拍伴侣。</span>'
      },
      {
        title: 'cyfx',
        message: this.result.answerList[2].contents[0],
        describe:
          '从<span>生肖、姓名学</span>等全面分析你一生的正财运合偏财运，<span>预知自己的财富类型和等级。</span>'
      },
      {
        title: 'syfx',
        message: this.result.answerList[3].contents[0],
        describe:
          '从<span>阴阳五行、生肖、笔画多少</span>分析你的一生的工作优势，<span>预知自己的工作竞争力，为您出谋划策。</span>'
      },
      {
        title: 'rjgx',
        message: this.result.answerList[4].contents[0],
        describe:
          '由<span>阴阳五行、生肖</span>来分析你的贵人运和人缘，<span>提前获悉自己的人助力。</span>'
      },
      {
        title: 'jkfx',
        message: this.result.answerList[5].contents[0],
        describe:
          '由<span>阴阳五行、生肖和姓名学等综合分析</span>你的健康，全面了解自己身体的强项和不足，<span>预知自己的易发疾病高发期，提前防御。</span>'
      }
    ]

    if (this.result.englishName.rank == 'Unranked') {
      this.result.englishName.rank = '1000名外'
    }
    this.result.promoteEnglishName = this.result.promoteEnglishName
    this.result.fiveElementName = this.result.fiveElement
    this.result.fiveElement = selectAttribute(this.result.fiveElement)

    try {
      TtxTrack.track('xing-ming-v2', 'FORTUNE_RESULT')
    } catch (e) {
      // console.log(e)
    }
  },
  methods: {
    backToHistory: function() {
      this.$router.push({ name: 'History' })
    },
    getTitleImg: function(filename) {
      return require('../assets/images/' + filename + '.png')
    }
  },
  computed: {
    ...mapGetters('fortune', {
      search: 'search',
      isLoading: 'isLoading'
    })
  }
}

let soalr = function(year) {
  var yearCH = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  return yearCH[year[0]] + yearCH[year[1]] + yearCH[year[2]] + yearCH[year[3]]
}

let selectAttribute = function(attribute) {
  switch (attribute) {
    case '甲木':
      return '01'
    case '乙木':
      return '02'
    case '丙火':
      return '03'
    case '丁火':
      return '04'
    case '戊土':
      return '05'
    case '巳土':
      return '06'
    case '庚金':
      return '07'
    case '辛金':
      return '08'
    case '壬水':
      return '09'
    case '葵水':
      return '10'
  }
}
</script>

<style scoped>
#gosee-nav h3 {
  background: url('../assets/images/retroaction.png') 0 0 no-repeat;
  background-size: 200%;
  height: 36px;
  width: 50px;
  margin: 0;
  font-weight: 700;
  position: absolute;
  right: 5%;
  top: 15%;
}
</style>
